import { Chip } from "matsuri-ui"
import { useTranslation } from "@/hooks/useTranslation"

export const EarlyCheckinChip = () => {
    const { t } = useTranslation()
    return (
        <Chip
            variant="filled"
            style={{
                fontWeight: "bold",
                backgroundColor: "#8e24aa",
                color: "#ffffff"
            }}
        >
            {t("アーリーチェックイン")}
        </Chip>
    )
}
